import { Trans } from '@lingui/react/macro';

import { InstanceLink } from '@/components/routing';
import { Badge } from '@/components/typography';

const STATUS_COMPLETE = 0;
const STATUS_INCOMPLETE = 1;
const STATUS_COMING_SOON = 2;
const STATUS_NOT_IN_PLAN = 3;

type Props = {
  isAvailable?: boolean;
  notIncludedInPlan?: boolean;
  isComplete?: boolean;
  disabled?: boolean;
  link?: string;
};

const getStatus = (isAvailable?: boolean, notIncludedInPlan?: boolean, isComplete?: boolean) => {
  if (!isAvailable) {
    return STATUS_COMING_SOON;
  }

  if (notIncludedInPlan) {
    return STATUS_NOT_IN_PLAN;
  }

  if (!isComplete) {
    return STATUS_INCOMPLETE;
  }

  return STATUS_COMPLETE;
};

const getStatusTag = (status: number) => {
  switch (status) {
    case STATUS_COMING_SOON:
      return (
        <Badge size="large" color="info">
          <Trans>Coming soon</Trans>
        </Badge>
      );
    case STATUS_NOT_IN_PLAN:
      return (
        <Badge size="large" color="critical">
          <Trans>Not in plan</Trans>
        </Badge>
      );
    case STATUS_INCOMPLETE:
      return (
        <Badge size="large" color="critical">
          <Trans>Incomplete</Trans>
        </Badge>
      );
    case STATUS_COMPLETE:
    default:
      return (
        <Badge size="large" color="success">
          <Trans>Complete</Trans>
        </Badge>
      );
  }
};

const HealthPodStatusTag = ({
  isAvailable,
  notIncludedInPlan,
  isComplete,
  disabled,
  link,
}: Props) => {
  const status = getStatus(isAvailable, notIncludedInPlan, isComplete);
  const tag = getStatusTag(status);

  if (disabled) {
    return tag;
  }

  return link ? <InstanceLink to={link}>{tag}</InstanceLink> : tag;
};

export default HealthPodStatusTag;
